import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 text-xs font-label text-foreground-600 tracking-wider uppercase whitespace-nowrap">
            Browse Categories
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Shop by Category
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-label max-w-[520px] mx-auto">
            Explore our complete collection of structured shopping categories — each linked to verified spreadsheet data for smarter purchasing decisions.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center p-3 md:p-4 bg-background-100 hover:bg-background-200/70 rounded-lg transition-all duration-300 cursor-pointer border border-background-200/60 hover:border-secondary-300/50"
            >
              <div className="w-full aspect-square rounded-md overflow-hidden mb-3 bg-background-50">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`Browse ${cat.name} on itaobuyspreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <span className="text-xs md:text-sm font-label font-medium text-foreground-800 text-center whitespace-nowrap leading-tight">
                {cat.name}
              </span>
              <span className="mt-1 flex items-center space-x-1 text-[10px] md:text-xs text-foreground-500 opacity-0 group-hover:opacity-100 transition-opacity font-label">
                <span>Explore</span>
                <i className="ri-arrow-right-up-line text-[10px]"></i>
              </span>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-500 text-background-50 font-label font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>View All Categories on Main Site</span>
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}